import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useLocation } from "react-router-dom";
import { Button, Form, FormGroup, Label, FormText, Row, Col, Alert, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { API_BASE_URL } from "../../../../_services/constant";
import { Card } from "@material-ui/core";
import { post } from "axios";

import {
  postMethod,
  validateMobile,
  singleParam,
  editUserGrid,
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
//import Select from "react-select";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import SubProductsTable from "./addRowProduct";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddProduct = (props) => {
  let queryParams = useQuery();
  const id = queryParams.get("id") == "" ? null : queryParams.get("id");
  const { register, handleSubmit, errors } = useForm();
  const [imageValidation, setImageValidation] = useState(false);
  const [imageValidationMsg, setImageValidationMsg] = useState("");
  const [productFieldErrors, setProductFieldErrors] = useState({});
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [categoryList, setCategoryList] = useState([]);
  const [stockHistoryList, setstockHistoryList] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const [isempty, setIsempty] = useState(true);
  const [showProductImages, setShowProductImages] = useState([]);
  const [divStockHistory, setdivStockHistory] = useState(false);
  const toggledivStockHistory = () => setdivStockHistory(!divStockHistory);
  const branch_type = localStorage.getItem("branch_type")

  const [subData, setSubData] = useState("")


  const [param, setParam] = useState({
    product_id: id == null ? "0" : id,
    product_subcategory_list: [],
    product_code: "", 
    product_name: "",
    branch_id: "",
    gender: "",
    price: null,
    qty: "1",
    addedQty: "0",
    discounted_price: 0,
    remarks: "",
    color:"",
    weight: "",
    size_length: "",
    metal: "",
    material: "",
    on_demand: "",
    category_id: "",
    available: false,
    exhibition: false,
    businesses: false,
    disable: false,
    trial: false,
    ptype:"",
    suitable:"",
    pcare:"",
    pattern:"",
    package:"",
    gst:"",
    product_images: [],
    branch_type:branch_type,
    product_brand_name: "",
  }); 
  
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);
 
  const insertData = async (values) => {
  const files = selectedImages;
  let formData = new FormData();

  let product_imagesCount = parseInt(param.product_images.length) + parseInt(files.length);
  const requiredErrors = {};

  if (!param.product_name || !param.product_name.trim()) {
    requiredErrors.product_name = "Product name is required";
  }

  if (!param.product_code || !param.product_code.trim()) {
    requiredErrors.product_code = "Branch code / Product code is required";
  }

  if (!param.category_id) {
    requiredErrors.category_id = "Category is required";
  }

  // Image validation
  if (product_imagesCount > 4) {
    setImageValidation(true);
    setImageValidationMsg("*Max 4 product image allowed.");
    document.getElementById("uploadImage").value = null;
    return;
  } else {
    setImageValidation(false);
    setImageValidationMsg("");
  }

  setProductFieldErrors(requiredErrors);

  if (Object.keys(requiredErrors).length > 0 || product_imagesCount === 0) {
    return;
  }

  setLoadInsert(true);

  // Prepare file uploads
  if (files.length > 0) {
    for (let j = 0; j < files.length; j++) {
      let file_name = "image-" + createGuid();
      param.product_images.push(file_name + "." + files[j].type.split("/")[1]);
      formData.append("files", files[j], file_name);
    }
  }

  try {
    const discountedPriceVal =
      param.discounted_price === "" ||
      param.discounted_price === null ||
      param.discounted_price === undefined
        ? 0
        : param.discounted_price;

    const finalParam = {
      ...param,
      discounted_price: discountedPriceVal,
    };

    if ((!param.product_id || param.product_id == 0)) {
      
  for (let i = 0; i < subData.length; i++) {
  const itemDiscounted =
    subData[i].discounted_price === "" ||
    subData[i].discounted_price === null ||
    subData[i].discounted_price === undefined
      ? discountedPriceVal
      : subData[i].discounted_price;

  const payload = {
    ...finalParam,
    ...subData[i],
    discounted_price: itemDiscounted,
    product_images: param.product_images
  };

  console.log("Final Payload =>", payload);

  const data = await postMethod(
    "api/masters/product/insert",
    payload
  );

  if (!data.data[0].valid) {
    setLoadInsert(false);
    return;
  }
}
    } else {
      // Single insert case
      const data = await postMethod("api/masters/product/insert", finalParam);
      if (!data.data[0].valid) {
        setLoadInsert(false);
        return;
      }
    }

    // After successful inserts
    if (files.length > 0) {
      await uploadImageFunc(formData); // <-- async safe
    }

    setSuccess(true);
    setTimeout(() => {
      props.history.push("/branch/product");
    }, 2000);
  } catch (err) {
    console.error("Insert error:", err);
    setLoadInsert(false);
  }
};

// console.log(param);
  const handleDelete = () => {
    var proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
      setLoadDelete(true);
      postMethod("api/masters/product/delete", { product_id: param.product_id }).then((data) => {
        if (data.data[0].valid) {
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/product");
          }, 2000);
        }
        else {
          setLoadDeleteMsg(data.error)
          setSuccessDelete(true);
          setTimeout(() => {
            setSuccessDelete(false);
          }, 4000);
          setLoadDelete(false);
        }
      });
    }
  };


 const handleDeleteImage = (image_id) => {
  const proceed = window.confirm(
    "Do you Really Wish to Delete this Image..?!"
  );

  if (!proceed) return;

  postMethod("api/masters/product/delete_image", {
    product_id: param.product_id,
    image_id: image_id,
  }).then((data) => {

    const updatedImages = data.data || [];

    setShowProductImages(updatedImages);

    setParam((prev) => ({
      ...prev,
      product_images: updatedImages.map(
        (item) => item.image_path
      ),
    }));

    setImageValidationMsg("");
  });
};

  function createGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  const uploadImageFunc = (formData) => {
    const url = API_BASE_URL + `api/masters/product/uploadImage`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "auth-token": localStorage.getItem("jwl_token"),
      },
    };

    post(url, formData, config).then(
      (response) => {
        setSuccess(true);
        setTimeout(() => {
          props.history.push("/branch/product");
        }, 2000);
      },
      (error) => {
        setSuccess(true);
      }
    );
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        marginLeft: -10,
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 310,
      },
    },
  };


  useEffect(() => {
    const fetchCatAndSubcat = async () => {
      try {
        // Fetch categories
        const categoryRes = await postMethod("api/masters/product/subcategory/getCategory", {});
        setCategoryList(categoryRes?.data || [])
      } catch (error) {
        console.error("Error fetching category/subcategory:", error);
      }
    };

    fetchCatAndSubcat();
  }, []);

  useEffect(() => {
  const fetchProductData = async () => {
    try {
      setLoad(true);

      if (id !== null) {
        const productId = window.atob(id);

        // Fetch product details
        const productRes = await postMethod("api/masters/product/preview", { product_id: productId });
        const product = productRes?.data?.[0];
        console.log("Fetched product data:", JSON.stringify(product));

        if (product) {
          // Extract images and subcategories
          const images = product.images?.map(img => img.image_path) || [];
          const subcategories = product.subcategorylist?.map(sub => sub.subcategory_id) || [];

          // Set state for product images and stock history
          setShowProductImages(product.images || []);
          setstockHistoryList(product.stockHistory || []);

          // Update form parameters
          setParam(prev => ({
            ...prev,
            product_id: product.product_id,
            product_name: product.product_name,
            product_code: product.product_code,
            price: product.price,
            qty: product.qty,
            // addedQty: product.qty,
            addedQty:queryParams.get("id") ? 0 : product.qty,
            remarks: product.remarks,
            gender: product.gender,
            discounted_price: product.discounted_price ?? 0,
            exhibition: product.exhibition,
            available: product.available,
            businesses: product.businesses,
            trial: product.trial,
            disable: product.disable,
            weight: product.weight,
            product_brand_name: product.product_brand_name,
            size_length: product.size_length,
            metal: product.metal,
            material: product.material,
            on_demand:
  product.on_demand?.toLowerCase() === "in stock"
    ? "In stock"
    : "Make to order",
            color:product.color,
            product_images: images,
            category_id: product.category_id,
            balance_qty: product.balance_qty,
            ptype:product.ptype,
            suitable:product.suitable,
            pcare:product.pcare,
            pattern:product.pattern,
            package:product.package,
            gst:product.gst,
            product_subcategory_list: subcategories,
          }));

          // Fetch subcategory list for the selected category
          const subcategoryRes = await postMethod("api/masters/product/subcategory/getSubcategoryForm", {
            category_id: product.category_id,
          });
          setSubcategory(subcategoryRes?.data || []);
        }
const categoryRes = await postMethod(
  "api/masters/product/subcategory/getCategory",
  {}
);

setCategoryList(categoryRes?.data || []);
    } 
        
      }

      // Fetch category list
     catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      setLoad(false);
    }
  };

  fetchProductData();
}, [id]);


  const getSubcategory = (category_id) => {
    postMethod("api/masters/product/subcategory/getSubcategoryForm", { category_id: category_id }).then((data) => {
      setSubcategory(data.data);
    });
  }
  const getDiscription = (sub_cat) => {
    // alert(description);
    if (sub_cat.length == 1) {
      postMethod("api/masters/product/subcategory/getSubcategorydescription", { subcategory_id: sub_cat[0] }).then((data) => {
        setIsempty(false);
        setParam({ ...param, remarks: data.data[0].description, product_subcategory_list: sub_cat })
        // document.getElementById("tdescription").value = data.data[0].description;
        // setRemarks(data.data[0].description);
      });
    } else {
      setParam({ ...param, product_subcategory_list: sub_cat })
    }
  }

  const [selectedImages, setSelectedImages] = useState([]);
 

  const handleImageChange = (e) => {
  const files = Array.from(e.target.files);

  const totalImages =
    showProductImages.length +
    selectedImages.length +
    files.length;

  if (totalImages > 4) {
    setImageValidationMsg(
      `Maximum 4 images allowed`
    );

    e.target.value = "";
    return;
  }

  setSelectedImages((prev) => [...prev, ...files]);

  setImageValidationMsg("");
};
  // -----------
const handleSubData = (data) => {
    setSubData(data);
  };
  // ----------
const removeSelectedImage = (index) => {
  const updated = [...selectedImages];
  updated.splice(index, 1);
  setSelectedImages(updated);
};

  return (
    <>


      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(insertData)} className="product-editor-form" noValidate>
        <input autocomplete="new-off"
          type="hidden"
          name="product_id"
          value={id == null ? "0" : param.product_id}
          ref={register}
        />
        <div className="card card-custom gutter-b product-editor-card">
          <div className="card-header product-editor-header">
            <div className="card-title product-editor-title">
              <span className="product-editor-icon">
                <i className="fa fa-cube"></i>
              </span>
              <div>
                <h3 className="card-label">{id ? "Edit Product" : "Add Product"}</h3>
                <p>Manage product details, categories, availability, and images.</p>
              </div>
            </div>
          </div>
          <div className="card-body product-editor-body">
            <Row className="product-editor-grid">
              <Col sm={4}>
                <FormGroup>
                  <Label>Product Name <span>*</span></Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.product_name}
                    className="form-control h-auto py-2 px-6"
                    name="product_name"
                    onChange={(e) => {
                      setParam({ ...param, product_name: e.target.value });
                      setProductFieldErrors({ ...productFieldErrors, product_name: "" });
                    }}
                    ref={register}
                  />
                  {productFieldErrors.product_name ? (
                    <span className="product-editor-field-error">
                      {productFieldErrors.product_name}
                    </span>
                  ) : null}
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Branch code /Product Code <span>*</span></Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.product_code}
                    className="form-control h-auto py-2 px-6"
                    name="product_code"
                    onChange={(e) => {
                      setParam({ ...param, product_code: e.target.value });
                      setProductFieldErrors({ ...productFieldErrors, product_code: "" });
                    }}
                    ref={register}
                  />
                  {productFieldErrors.product_code ? (
                    <span className="product-editor-field-error">
                      {productFieldErrors.product_code}
                    </span>
                  ) : null}
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>Shop for</Label>
                  <select className="form-control h-auto py-2 px-6" value={param.gender} onChange={(e) => {
                    setParam({ ...param, gender: e.target.value });
                  }}>
                    <option value="" selected>--select--</option>
                    <option value="Women">Women</option>
                    <option value="Men">Men</option>
                    <option value="Kid">Kid</option>
                    <option value="Unisex">Unisex</option>
                  </select>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Category <span>*</span></Label>
                  <select
                    className="form-control h-auto py-2 px-6"
                    onChange={(e) => {
                      {
                        setParam({ ...param, category_id: e.target.value })
                        setProductFieldErrors({ ...productFieldErrors, category_id: "" });
                        getSubcategory(e.target.value)
                      }
                    }}
                    name="category_id"
                    value={param.category_id}
                    ref={register}
                  >
                    <option value="">--Select--</option>
                    {categoryList.map((prop, i) => {
                      return (
                        <option key={i} value={prop.category_id}>
                          {prop.category_name}
                        </option>
                      );
                    })}
                  </select>
                  {productFieldErrors.category_id ? (
                    <span className="product-editor-field-error">
                      {productFieldErrors.category_id}
                    </span>
                  ) : null}
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>SubCategory</Label>
                  <Select
                    style={{ width: "100%", height: 42 }}
                    multiple
                    value={param.product_subcategory_list}
                    //value={[]}
                    name="subcategory_id"
                    onChange={(e) => {
                      getDiscription(e.target.value)
                    }}
                    ref={register}
                    input={<OutlinedInput id="select-multiple" />}
                    MenuProps={MenuProps}
                  >
                    {subcategory.length > 0 ? subcategory.map((item) => (
                      <MenuItem key={item.subcategory_id} value={item.subcategory_id}>
                        {item.subcategory_name + "(" + item.category_name + ")"}
                      </MenuItem>
                    )) : null}
                  </Select>
                </FormGroup>
              </Col>
            {/* ------------ */}

              {/* <Col sm={4}>
                <FormGroup>
                  <Label>Price</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.price}
                    className="form-control h-auto py-2 px-6"
                    name="price"
                    onChange={(e) => setParam({ ...param, price: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Discounted Price</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.discounted_price}
                    className="form-control h-auto py-2 px-6"
                    name="price" discounted_price
                    onChange={(e) => setParam({ ...param, discounted_price: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Modal isOpen={divStockHistory} toggle={toggledivStockHistory} style={{ marginTop: "100px" }}>
                <ModalHeader toggle={toggledivStockHistory}>Stock History</ModalHeader>
                <ModalBody style={{ maxHeight: "238px", overflow: 'auto' }} >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>sno</th>
                        <th>Transaction Detail</th>
                        <th>Qty</th>
                        <th>Date Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stockHistoryList.map((item, index) => {
                        return (
                          <tr className={index == stockHistoryList.length - 1 ? "text-danger" : ""} >
                            <td>{index + 1}</td>
                            <td>{item.Text}</td>
                            <td>{item.Qty}</td>
                            <td >{item.datetime}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={toggledivStockHistory}>Update</Button>{' '}
                  <Button color="secondary" onClick={toggledivStockHistory}>Cancel</Button>
                </ModalFooter>
              </Modal>
              <Col sm={4}>
                <FormGroup>
                  <Label className="text-info">Add Quantity
                    <i className="fa fa-info-circle text-dark ml-2" onClick={toggledivStockHistory}> </i>
                    <a  ></a> </Label>
                  <input autocomplete="new-off"
                    style={{ borderColor: "var(--info)" }}
                    type="text"
                    value={param.addedQty}
                    className="form-control h-auto py-2 px-6"
                    name="addedQty"
                    onChange={(e) => setParam({ ...param, addedQty: e.target.value ,qty:e.target.value })}
                    ref={register}
                  />
                  <b className="text-info text-bold" >(Balance Qty {param.balance_qty})</b> {" "}
                  <b className="text-danger text-bold" >(Last Qty Added {param.qty}) </b>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Weight</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.weight}
                    className="form-control h-auto py-2 px-6"
                    name="price" weight
                    onChange={(e) => setParam({ ...param, weight: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Size/Length</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.size_length}
                    className="form-control h-auto py-2 px-6"
                    name="price" size_length
                    onChange={(e) => setParam({ ...param, size_length: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col> */}

              <Col sm={4}>
  <FormGroup>
    <Label>Brand Name</Label>
    <input
      autoComplete="new-off"
      type="text"
      value={param.product_brand_name}
      className="form-control h-auto py-2 px-6"
      name="product_brand_name"
      onChange={(e) =>
        setParam({
          ...param,
          product_brand_name: e.target.value,
        })
      }
      ref={register}
    />
  </FormGroup>
</Col>
        <Col sm={4}>
          <FormGroup>
            <Label>Weight</Label>
            <input
              autoComplete="new-off"
              type="text"
              value={param.weight}
              className="form-control h-auto py-2 px-6"
              name="weight"
              onChange={(e) => setParam({ ...param, weight: e.target.value })}
              ref={register}
            />
          </FormGroup>
        </Col>
        

{(!param.product_id || param.product_id == 0) ? (
  <> 
  </>
) : (
  <> {/* Non-Retailer ke liye inputs */} 
   <Col sm={4}>
          <FormGroup>
            <Label>Price</Label>
            <input
              autoComplete="new-off"
              type="text"
              value={param.price}
              className="form-control h-auto py-2 px-6"
              name="price"
              onChange={(e) => setParam({ ...param, price: e.target.value })}
              ref={register}
            />
          </FormGroup>
        </Col>

         <Col sm={4}>
          <FormGroup>
            <Label>Discounted Price</Label>
            <input
              autoComplete="new-off"
              type="text"
              value={param.discounted_price}
              className="form-control h-auto py-2 px-6"
              name="discounted_price"
              onChange={(e) =>
                setParam({ ...param, discounted_price: e.target.value })
              }
              ref={register}
            />
          </FormGroup>
        </Col>
{/*
        <Col sm={4}>
          <FormGroup>
            <Label className="text-info">
              Add Quantity
              <i
                className="fa fa-info-circle text-dark ml-2"
                onClick={toggledivStockHistory}
              ></i>
            </Label>
            <input
              autoComplete="new-off"
              style={{ borderColor: "var(--info)" }}
              type="text"
              value={param.addedQty}
              className="form-control h-auto py-2 px-6"
              name="addedQty"
              onChange={(e) =>
                setParam({ ...param, addedQty: e.target.value, qty: e.target.value })
              }
              ref={register}
            />
            <b className="text-info text-bold">
              (Balance Qty {param.balance_qty})
            </b>{" "}
            <b className="text-danger text-bold">
              (Last Qty Added {param.qty}){" "}
            </b>
          </FormGroup>
        </Col> */}
        <Col sm={4}>
          <FormGroup>
            <Label>Size/Length</Label>
            <input
              autoComplete="new-off"
              type="text"
              value={param.size_length}
              className="form-control h-auto py-2 px-6"
              name="size_length"
              onChange={(e) =>
                setParam({ ...param, size_length: e.target.value })
              }
              ref={register}
            />
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <Label>Color</Label>
            <input
              autoComplete="new-off"
              type="text"
              value={param.color}
              className="form-control h-auto py-2 px-6"
              name="color"
              onChange={(e) => setParam({ ...param, color: e.target.value })}
              ref={register}
            />
          </FormGroup>
        </Col>
  </>
)}
              {/* ----------- */}
              <Col sm={4}>
                <FormGroup>
                  <Label>Metal</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.metal}
                    className="form-control h-auto py-2 px-6"
                    name="metal" 
                    onChange={(e) => setParam({ ...param, metal: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>Material</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.material}
                    className="form-control h-auto py-2 px-6"
                    name="material" 
                    onChange={(e) => setParam({ ...param, material: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>



{/* ---------------------------------------------- */}
 <Col sm={4}>
                <FormGroup>
                  <Label>Product Type</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.ptype}
                    className="form-control h-auto py-2 px-6"
                    name="ptype"
                    onChange={(e) => setParam({ ...param, ptype: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>

               <Col sm={4}>
                <FormGroup>
                  <Label>Suitable</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.suitable}
                    className="form-control h-auto py-2 px-6"
                    name="suitable"
                    onChange={(e) => setParam({ ...param, suitable: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
  <FormGroup>
    <Label>Product Care</Label>
    <input
      autoComplete="new-off"
      type="text"
      value={param.pcare}
      className="form-control h-auto py-2 px-6"
      name="pcare"
      onChange={(e) => setParam({ ...param, pcare: e.target.value })}
      ref={register}
    />
  </FormGroup>
</Col>
               <Col sm={4}>
                <FormGroup>
                  <Label>Pattern</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.pattern}
                    className="form-control h-auto py-2 px-6"
                    name="pattern"
                    onChange={(e) => setParam({ ...param, pattern: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>

               <Col sm={4}>
                <FormGroup>
                  <Label>Package</Label>
                  <input autocomplete="new-off"
                    type="text"
                    value={param.package}
                    className="form-control h-auto py-2 px-6"
                    name="package"
                    onChange={(e) => setParam({ ...param, package: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>

               <Col sm={4}>
               <FormGroup>
  <Label>GST%</Label>
  <div style={{ position: "relative" }}>
    <input
      autoComplete="off"
      type="text"
      value={ param?.gst !== null &&
        param?.gst !== undefined &&
        param?.gst !== ""
          ? `${param.gst}%`
          : ""}
      className="form-control h-auto py-2 px-6"
      name="gst"
      onChange={(e) => {
        let val = e.target.value.replace("%", ""); // remove %
        if (/^\d*\.?\d*$/.test(val)) {             // allow only numbers and decimal
          setParam({ ...param, gst: val });
        }
      }}
      ref={register}
    />
  </div>
</FormGroup>
              </Col>

{/*  */}
              <Col sm={4}>
                <FormGroup>
                  <Label>Availability</Label>
                  <select
                    className="form-control h-auto py-2 px-6"
                    onChange={(e) => {
                      {
                        setParam({ ...param, on_demand: e.target.value })
                      }
                    }}
                    name="on_demand"
                    value={param.on_demand}
                    ref={register}
                  >
                    <option value="">--Select--</option>
                    <option value="In stock">In stock</option>
                    <option value="Make to order">Make to order</option>
                  </select>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <div className="product-editor-option-column">
                  <label className="product-editor-option-row">
                    <input autocomplete="new-off"
                      type="checkbox"
                      checked={param.exhibition}
                      name="exhibition"
                      onChange={(e) => setParam({ ...param, exhibition: !param.exhibition })}
                      ref={register}
                    />
                    Exhibition
                  </label>
                  <label className="product-editor-option-row">
                    <input autocomplete="new-off"
                      type="checkbox"
                      checked={param.businesses}
                      name="businesses"
                      onChange={(e) => setParam({ ...param, businesses: !param.businesses })}
                      ref={register}
                    />
                    Businesses
                  </label>
                  <label className="product-editor-option-row product-editor-option-danger">
                    <input autocomplete="new-off"
                      type="checkbox"
                      checked={param.disable}
                      name="disable"
                      onChange={(e) => setParam({ ...param, disable: !param.disable })}
                      ref={register}
                    />
                    Disable
                  </label>
                  <label className="product-editor-option-row">
                    <input autocomplete="new-off"
                      type="checkbox"
                      checked={param.trial}
                      name="trial"
                      onChange={(e) => setParam({ ...param, trial: !param.trial })}
                      ref={register}
                    />
                    Trial at home
                  </label>
                </div>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label>Description</Label>
                  <textarea
                    // type="textarea"
                    value={param.remarks}
                    className="form-control h-auto py-2 px-6"
                    name="remarks"
                    id="tdescription"
                    onChange={(e) => setParam({ ...param, remarks: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>
              {/*  <Col sm={1}>
                <FormGroup>
                  <Label>Available</Label>
                    <input autocomplete="new-off"
                    type="checkbox"                 
                    checked={param.available}
                    className="form-control h-auto py-2 px-6"
                    name="available"
                    onChange={(e) => setParam({ ...param, available: !param.available })}
                    ref={register}
                  />
                </FormGroup>
              </Col>*/}
              {/* <Col sm={4} className="d-flex">
                <Card body className="col-md-12">
                  <Label>
                    Product Image 4 (251X230) (<label className="text-danger">select multiple images</label>) {imageValidation ? <label className="text-danger">{imageValidationMsg}</label> : null}<br />

                    <input autocomplete="new-off"
                      id="uploadImage"
                      type="file"
                      multiple={true}
                      accept="image/*"
                      name="Choose Image"
                    />
                  </Label>
                </Card>
              </Col> */}


<Col md={12} lg={12} className="d-flex">
      <Card body className="col-md-12 product-editor-upload-card">
        <div className="product-editor-upload-head">
          <span className="product-editor-upload-icon">
            <i className="fa fa-cloud-upload"></i>
          </span>
          <div>
            <h5>Product Images </h5>
            <p>Upload up to 4 images. Recommended 251 x 230.</p>
          </div>
        </div>
        <div className="product-editor-upload-content">
          <Label className="product-editor-upload-control">
            <input
              autoComplete="new-off"
              id="uploadImage"
              type="file"
              multiple={true}
              accept="image/*"
              name="Choose Image"
              onChange={handleImageChange}
            />
            <i className="fa fa-image"></i>
            <strong>Choose images</strong>
          </Label>
<div className="image-preview product-editor-preview">

  {/* Existing Images */}
  {showProductImages?.map((image, index) => (
    <div
      key={`old-${index}`}
      style={{
        position: "relative",
        display: "inline-block",
        margin: "10px",
      }}
    >
      <img
        src={
          image.isImageUrl
            ? image.image_path
            : `${image.url}${image.image_path}`
        }
        alt=""
        width="100"
        height="100"
        style={{
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
      />

      <span
        onClick={() => handleDeleteImage(image.image_id)}
        style={{
          position: "absolute",
          top: "-8px",
          right: "-8px",
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          background: "red",
          color: "#fff",
          cursor: "pointer",
          textAlign: "center",
          lineHeight: "22px",
          fontWeight: "bold",
        }}
      >
        ×
      </span>
    </div>
  ))}

  {/* Newly Selected Images */}
  {selectedImages?.map((image, index) => (
    <div
      key={`new-${index}`}
      style={{
        position: "relative",
        display: "inline-block",
        margin: "10px",
      }}
    >
      <img
        src={URL.createObjectURL(image)}
        alt=""
        width="100"
        height="100"
        style={{
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
      />

      <span
        onClick={() => removeSelectedImage(index)}
        style={{
          position: "absolute",
          top: "-8px",
          right: "-8px",
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          background: "red",
          color: "#fff",
          cursor: "pointer",
          textAlign: "center",
          lineHeight: "22px",
          fontWeight: "bold",
        }}
      >
        ×
      </span>
    </div>
  ))}

  {showProductImages.length === 0 &&
    selectedImages.length === 0 && (
      <div className="product-editor-preview-empty">
        Selected images will appear here
      </div>
  )}

</div>
   
        </div>
        {imageValidationMsg && (
          <small className="product-editor-field-error product-editor-image-error">
            {imageValidationMsg}
          </small>
        )}
      </Card>
    </Col>
              <Col sm={11}>
                <FormGroup className="product-editor-clear-row">
                  <Button
  type="button"
  title="Clear"
  className="product-editor-clear-btn"
  style={{
    marginTop: "15px",
   
  }}
  onClick={() => {
    setParam({ ...param, remarks: "" });
  }}
>
  Clear
</Button>
                </FormGroup>
              </Col>




            </Row>

            
            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? <Alert color="danger">{loadDeleteMsg}</Alert> : null}
          </div>
          <div>
 {
 (param?.product_id == 0 || param?.product_id == null) && (
   <SubProductsTable data={param} sendDataToMain={handleSubData} />
 )}
</div>

          <div className="card-footer text-right product-editor-footer">
            <a href="/branch/product" className="btn btn-secondary mr-2 product-editor-cancel-btn">
              Cancel
            </a>
            {id && (
              loadDelete ? <button type="button" className="btn btn-danger mr-2 product-editor-action-btn">
                Deleting..
              </button> :
                <button type="button" onClick={handleDelete} className="btn btn-danger mr-2 product-editor-action-btn">
                  Delete
                </button>
            )}
            {loadInser ?
              <button type="button" className="btn btn-primary product-editor-action-btn">
                Saving..
              </button> : <button type="submit" className="btn btn-primary product-editor-action-btn">
                Save
              </button>}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddProduct;
